import _ from 'lodash'
import config from '../../../components/config'
import constants from '../../../components/constants'
import LinearGauge from './linear-gauge-model'
import allowThresholdLabels from './allow-threshold-labels'
import createWob from '../create-wob'
import ScorecardNode from '../../../scorecards/scorecard-node'
import AddDomainObjectEndpoint
	from '../../../components/bootslide/add-domain-object-endpoint'
import { DATA_SOURCE_PROPERTY } from '../shape/shape-widget-properties'
const { metricish } = ScorecardNode

const LinearGaugeAddOption = AddDomainObjectEndpoint.extend({

	selectorOptions: function(opt) {
		var selectorOpts = AddDomainObjectEndpoint.prototype.selectorOptions.apply(this, arguments)

		return _.extend(selectorOpts, {
			params: {
				// need the scoring type so I can prevent unscored metrics
				scoringType: true
			}
		})
	},

	allowSelect: function (node) {
		if (!metricish(node)) {
			return true
		}

		let scoringType = config.scoringType(node.scoringTypeId)
		// #50270 Don't allow selecting unscored or unscored text metrics
		let isUnscored =
			_.get(scoringType, 'standardScoringType') == constants.UNSCORED ||
			_.get(scoringType, 'kpiValueType') == constants.UNSCORED_TEXT
		return !isUnscored
	},

	add: function (node) {
		let properties = _.extend(
			{},
			DEFAULT_LINEAR_GAUGE_PROPERTIES,
			{
				section: this.section,
				domainObjectId: node.id,
				showThresholds: allowThresholdLabels(this.section, node),
			})

		if (this.section === 'initiatives') {
			properties[DATA_SOURCE_PROPERTY] = 'percent-complete'
		}

		var widget = new LinearGauge(
			{ properties },
			{ domainObject: node })

		createWob(this.canvas, widget, { fetchData: true }, this.bootslideMenu)
	}

})

const DEFAULT_LINEAR_GAUGE_PROPERTIES = {
	type: 'linear-gauge',
	periodDelta: '0',
	showLabel: true,
	showPointerLabel: true,
	showScore: false,
	showPrevious: true,
	drilldownSection: 'default',
	gaugeHeight: 78,
	fontSize: 16,
	background: 'white',
	showThresholds: true
}

export default LinearGaugeAddOption
export { DEFAULT_LINEAR_GAUGE_PROPERTIES }

LinearGaugeAddOption.__filename__ = 'dashboards/widgets/linear-gauge/linear-gauge-add-option.js'
